document.addEventListener('DOMContentLoaded', function () {
  const ActionsShop = document.querySelector('.checkout-button')
  const ButtonCheckout = document.querySelector('.shipping-info')

  const onScroll = () => {
    const scroll = document.documentElement.scrollTop
    const Elem = ButtonCheckout.offsetTop;

    if (scroll > Elem) {
      ActionsShop.classList.add('show');
    } else {
      ActionsShop.classList.remove('show')
    }
  }
  window.addEventListener('scroll', onScroll)

})
